/**
 * 設定環境（環境切り替え定数を設定）
 */
export const SET_ENV = 2;
/**
 * 環境切り替え定数
 */
export const ENV = {
    DEV: 0,     //開発環境
    TEST: 1,    //テスト環境
    USER: 2,    //本番 ユーザサイト
    ADMIN: 3,   //本番 管理サイト
}

// APIを実行するときのKEY情報
export const API = {
    API_KEY: "SfdE2mSS2xrSGCjB4kCE"
};

// DataGrid 1ページの表示行数
export const PAGE_SIZE = 25;

// 輸出相手国CSVアップロード用
export const CSV_EXPCOUNT = {
    NAME: 0,
    KANA: 1,
    EN: 2,
    CODE: 3,
    NAME3: 4,
    NAME2: 5,
    AREA_NAME: 6,
    ISO: 7,
    JA_INIT: 8
};

// 植物検疫CSVアップロード用
export const CSV_PLANTQUAR = {
    COUNTRY_NAME: 0,
    PRODUCT_CODE: 1,
    PACKING: 2,
    EX_CODE: 3,
    SUPPLEMENT: 4,
    SPEC_COND: 5,
    URL: 6,
    ENABLE_DATE: 7,
    DISABLE_DATE: 8,
    COUNTRY_CODE: 9
};

// 動物検疫CSVアップロード用
export const CSV_ANIMALQUAR = {
    COUNTRY_NAME: 0,
    PRODUCT_CODE: 1,
    EX_CODE: 2,
    SUPPLEMENT: 3,
    SPEC_COND: 4,
    URL: 5,
    MARINE_EX_CODE: 6,
    MARINE_SUPPLEMENT: 7,
    MARINE_SPEC_COND: 8,
    MARINE_URL: 9,
    ENABLE_DATE: 10,
    DISABLE_DATE: 11,
    COUNTRY_CODE: 12
};

// 放射線規制CSVアップロード用
export const CSV_RADREG = {
    COUNTRY_NAME: 0,
    PREF_CODE: 1,
    PRODUCT_CODE: 2,
    EX_CODE: 3,
    SUPPLEMENT: 4,
    REGULATION: 5,
    REMARKS: 6,
    INQUIRY: 7,
    URL: 8,
    ENABLE_DATE: 9,
    DISABLE_DATE: 10,
    COUNTRY_CODE: 11,
    // PRODUCT_NAME: 12,
    RADIO_ID: 12,
};

// 残留農薬検疫CSVアップロード用
export const CSV_RACQUAR = {
    COUNTRY_NAME: 0,
    PRODUCT_CODE: 1,
    EX_CODE: 2,
    SUPPLEMENT: 3,
    SPEC_COND: 4,
    URL: 5,
    ENABLE_DATE: 6,
    DISABLE_DATE: 7,
    COUNTRY_CODE: 8
};

// 食品添加物検疫CSVアップロード用
export const CSV_EUQUAR = {
    COUNTRY_NAME: 0,
    PRODUCT_CODE: 1,
    EX_CODE: 2,
    SUPPLEMENT: 3,
    SPEC_COND: 4,
    URL: 5,
    ENABLE_DATE: 6,
    DISABLE_DATE: 7,
    COUNTRY_CODE: 8
};

// 添加物一覧CSVアップロード用
export const CSV_ADDITIVE = {
    CATEGORY_NUMBER: 0,
    E_NUMBER: 1,
    NAME_JP: 2,
    NAME_EN: 3,
    JA_INIT: 4,
    REGULATION: 5,
    REMARKS: 6,
    NAME_FLG: 7
};

// 食品カテゴリー一覧CSVアップロード用
export const CSV_FOODCATEGORY = {
    PRIMARY: 0,
    SECONDARY: 1,
    TERTIARY: 2,
    QUATERNARY: 3,
    CATEGORY_NUMBER: 4,
    HIERARCHY_NUMBER: 5,
    CONTENT: 6
};

// 脚注CSVアップロード用
export const CSV_FOOTNOTE = {
    FOOTNOTE_NUMBER: 0,
    FOOTNOTE: 1
};

// 食品添加物CSVアップロード用
export const CSV_FOODADDITIVE = {
    E_NUMBER: 0,
    INS_NUMBER: 1,
    CATEGORY_NUMBER: 2,
    GROUP: 3,
    MAX_VALUE: 4,
    FOOTNOTE_NUMBER: 5,
    EXCEPTION: 6
};

// 組み合わせCSVアップロード用
export const CSV_COMBINATION = {
    E_NUMBER: 0,
    GROUP_NAME: 1,
    CATEGORY_NUMBER: 2,
    GROUP: 3,
    MAX_VALUE: 4,
    FOOTNOTE_NUMBER: 5,
    EXCEPTION: 6
};

/**
 * 残留農薬　品目共通項目マスタ
 */
export const CSV_RAC_ITEM_COM = {
    COUNTRY_NAME: 0,
    REGULATION_MODEL: 1,
    PRIORITY1: 2,
    PRIORITY2: 3,
    PRIORITY3: 4,
    ACQUISITION_DATE: 5,
    RELATED_LAWS: 6,
    MRL: 7,
    URL: 8,
}

/**
 * 残留農薬　プルダウン－輸出先マスタ
 */
export const CSV_RAC_EXP_COUNTRY = {
    COUNTRY_NAME: 0
}

/**
 * 残留農薬　プルダウン－品目マスタ
 */
export const CSV_RAC_PRODUCT = {
    PRODUCT_NAME: 0,
    SITE: 1,
}
/**
 * 残留農薬　プルダウン－英字頭文字マスタ
 */
export const CSV_RAC_EN = {
    EN_INITIALS: 0,
}

/**
 * 残留農薬　プルダウン－和名頭文字マスタ
 */
export const CSV_RAC_JA = {
    JA_INITIALS: 0,
}

/**
 * 残留農薬　基準値マスタ
 */
export const CSV_RAC_STD_VAL = {
    COUNTRY_NAME: 0,
    PRODUCT_NAME: 1,
    PESTICIDE: 2,
    PESTICIDES_NAME: 3,
    STANDARD_VALUE: 4,
    IS_REGIST: 5,
    IS_APPLY: 6,
}

/**
 * 残留農薬　各国資料等で検索する場合の品目名マスタ
 */
export const CSV_RAC_CONT_PROD = {
    PRODUCT_NAME: 0,
    COUNTRY_NAME: 1,
    COUNTRY_PRODUCT_NAME: 2,
    SPRECIMEN: 3,
    REMARKS: 4,
}

/**
 * 残留農薬　農薬
 */
export const CSV_RAC_PESTICIDE = {
    PRODUCT_NAME: 0,
    PESTICIDE: 1,
    PESTICIDES_NAME: 2,
    JA_INITIALS: 3,
    EN_INITIALS: 4,
    IS_REGIST: 5,
}

/**
 * 残留農薬　農薬の製品名
 */
export const CSV_RAC_PESTICIDE_PRODUCTS = {
    REGISTRATION_NUMBER: 0,
    PESTICIDE_TYPE: 1,
    PESTICIDE_NAME: 2,
    COMPANY_NAME: 3,
    PESTICIDE: 4,
    TOTAL_COUNT: 5,
    CONCENTRATION: 6,
    MIXED_COUNT: 7,
    INTENDED_USE: 8,
    DOSAGE_TYPE: 9,
    REGISTRATION_DATE: 10,
}

/**
 * メッセージ
 */
export const MSG = {
    TIMEOUT_LOGIN: "タイムアウトしました。再度ログインしてください。",
    EXCEPTION: "例外が発生しました。管理者にお問い合わせください。",
}